export type VariantType = 'plain' | 'component';
export type CurrencyType =
  | 'PLN'
  | 'EUR'
  | 'CHF'
  | 'USD'
  | 'GPB'
  | 'RON'
  | 'NONE';

export enum CurrencySign {
  PLN = 'zł',
  EUR = '€',
  CHF = 'fr.',
  USD = '$',
  GPB = '£',
  RON = 'lei',
  NONE = ''
}
